import classNames from 'classnames'
import IconButton from 'components/common/iconButton/IconButton'
import { CustomColorsRef, IconSizes } from 'types/general'

interface CustomSlideButtonsProps {
  className: string
  handlePrev: (e: any) => void
  handleNext: (e: any) => void
}

const CustomSlideButtons = ({
  className,
  handlePrev,
  handleNext,
}: CustomSlideButtonsProps) => {
  return (
    <div>
      <div
        className={classNames(
          className,
          'absolute left-2 top-1/2 z-20 flex -translate-y-1/2 items-center rounded bg-white/50'
        )}
      >
        <IconButton
          icon="regular-chevron-left"
          size={IconSizes.XXL}
          color={CustomColorsRef.Secondary}
          hoverColor={CustomColorsRef.SecondaryDark}
          handleClick={e => handlePrev(e)}
        />
      </div>
      <div
        className={classNames(
          className,
          'absolute right-2 top-1/2 z-20 flex -translate-y-1/2 items-center rounded bg-white/50'
        )}
      >
        <IconButton
          icon="regular-chevron-right"
          size={IconSizes.XXL}
          color={CustomColorsRef.Secondary}
          hoverColor={CustomColorsRef.SecondaryDark}
          handleClick={e => handleNext(e)}
        />
      </div>
    </div>
  )
}

export default CustomSlideButtons
